import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.submitArticle}
          >
            保存
          </button>
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            onClick={this.props.togglePreview}
          >
            預覽
          </button>
        </div>

        <div className="d-flex align-items-center py-4">
          <div className="custom-control custom-radio">
            <input
              className="custom-control-input"
              id="customRadio1"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "draft"}
              value="draft"
              onChange={(e) => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio1">
              草稿文章
            </label>
          </div>
          <div className="custom-control custom-radio ml-2">
            <input
              className="custom-control-input"
              id="customRadio2"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "approval_pending"}
              value="approval_pending"
              onChange={(e) => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio2">
              正式發布
            </label>
          </div>
        </div>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={(e) => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            作者
          </label>
          <p>{this.props.data.author}</p>
        </FormGroup>
        <label className="form-control-label">選擇分類</label>
        <div
          className="mb-3"
          style={{
            border: "1px solid",
            borderColor: "#cccccc",
            borderRadius: "4px",
          }}
        >
          <div className="d-flex justify-content-around py-4">
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-102"
                  id="check-102"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(102) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={102}
                />
                <label className="custom-control-label" htmlFor="check-102">
                  春節遊園會
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-103"
                  id="check-103"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(103) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={103}
                />
                <label className="custom-control-label" htmlFor="check-103">
                  麥當勞教育展
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-104"
                  id="check-104"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(104) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={104}
                />
                <label className="custom-control-label" htmlFor="check-104">
                  其他活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-107"
                  id="check-107"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(107) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={107}
                />
                <label className="custom-control-label" htmlFor="check-107">
                  商家信息
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-109"
                  id="check-109"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(109) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={109}
                />
                <label className="custom-control-label" htmlFor="check-109">
                  美食
                </label>
              </div>
            </div>

            <div className="px-2 py-1" style={{ flex: 1 }}>
              {" "}
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-111"
                  id="check-111"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(111) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={111}
                />
                <label className="custom-control-label" htmlFor="check-111">
                  健康養生
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-106"
                  id="check-106"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(106) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={106}
                />
                <label className="custom-control-label" htmlFor="check-106">
                  促銷活動
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-111"
                  id="check-111"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(111) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={111}
                />
                <label className="custom-control-label" htmlFor="check-111">
                  健康養生
                </label>
              </div>
            </div>
            <div className="px-2 py-1" style={{ flex: 1 }}>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-112"
                  id="check-112"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(112) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={112}
                />
                <label className="custom-control-label" htmlFor="check-112">
                  娛樂
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-113"
                  id="check-113"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(113) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={113}
                />
                <label className="custom-control-label" htmlFor="check-113">
                  旅遊
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-159"
                  id="check-159"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(159) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={159}
                />
                <label className="custom-control-label" htmlFor="check-159">
                  體育
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  name="check-110"
                  id="check-110"
                  type="checkbox"
                  checked={
                    this.props.data.category_ids
                      ? this.props.data.category_ids.indexOf(110) !== -1
                      : false
                  }
                  onChange={(e) => this.props.handleCheckBoxChange(e)}
                  value={110}
                />
                <label className="custom-control-label" htmlFor="check-110">
                  房地產
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleForm;
